import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CalculatorIcon = (props: SvgIconProps) => {
    const fill = props.fill ?? 'none';
    return (
        <SvgIcon viewBox="0 0 24 24" {...props} fill={fill} sx={{ ...props.sx, fill }}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.4279 21H6.57214C5.42786 21 4.5 20.134 4.5 19.0659V4.93411C4.5 3.86605 5.42786 3 6.57214 3H17.4268C18.5721 3 19.5 3.86605 19.5 4.93411V19.0649C19.5 20.134 18.5721 21 17.4279 21V21Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.5 7.5L15.5 7.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.25 16.175C9.292 16.175 9.325 16.208 9.325 16.25C9.325 16.292 9.292 16.325 9.25 16.325C9.208 16.325 9.175 16.292 9.175 16.25C9.175 16.2095 9.208 16.175 9.25 16.175"
                stroke="currentColor"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.75 16.175C14.792 16.175 14.825 16.208 14.825 16.25C14.825 16.292 14.792 16.325 14.75 16.325C14.708 16.325 14.675 16.292 14.675 16.25C14.6735 16.208 14.708 16.175 14.75 16.175"
                stroke="currentColor"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.25 11.675C9.292 11.675 9.325 11.708 9.325 11.75C9.325 11.792 9.292 11.825 9.25 11.825C9.208 11.825 9.175 11.792 9.175 11.75C9.175 11.7095 9.208 11.675 9.25 11.675"
                stroke="currentColor"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.75 11.675C14.792 11.675 14.825 11.708 14.825 11.75C14.825 11.792 14.792 11.825 14.75 11.825C14.708 11.825 14.675 11.792 14.675 11.75C14.6735 11.708 14.708 11.675 14.75 11.675"
                stroke="currentColor"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default CalculatorIcon;
